import clsx from 'clsx';
import React, { useMemo } from 'react';

interface FakeInputProps {
  inputSize: 'small' | 'medium' | 'large' | 'xlarge' | 'xsmall';
  wrapperClassName: string;
  label: string;
  value: string;
}

const FakeInput = ({
  inputSize = 'medium',
  wrapperClassName,
  label,
  value,
}: FakeInputProps) => {
  const sizeClass = useMemo(() => {
    switch (inputSize) {
      case 'small':
      case 'xsmall':
        return 'input-wrapper--sm';
      case 'large':
        return 'input-wrapper--lg';
      case 'xlarge':
        return 'input-wrapper--xl';
      case 'medium':
      default:
        return 'input-wrapper--md';
    }
  }, [inputSize]);

  return (
    <div
      className={clsx(
        wrapperClassName,
        'input-wrapper rounded border  border-gray-300',
        sizeClass
      )}
    >
      <div className="fake-input relative flex">
        <span className="text-lg">{value}</span>
        <span className="fake-input-label">{label}</span>
      </div>
    </div>
  );
};

export default FakeInput;
